<template>
  <div class="office-list-phone">
    <div @scroll="handleReachBottom($event)" class="scroll-container">
      <div class="list-empty" v-if="totalCount === 0">暂无数据</div>
      <Card v-for="item in datas" :key="item.roomId" @click.native="officeDetail(item)">
        <Row>
          <Col class="office-img" span="7">
            <img :src="item.imageUrl" />
          </Col>
          <Col class="right-msg" span="17">
            <h3 :title="item.highlights">{{ item.highlights }}</h3>
            <div class="addr" :title="item.address">
              <Icon type="ios-pin" />
              {{ item.address }}
            </div>
            <div class="o-condition">
              <span>标准交付 {{ item.standards }}</span>
              <span>现房 {{ item.houseType }}</span>
              <span>中央空调 {{ item.equipment }}</span>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
    <Spin fix v-if="loading"> </Spin>
    <!-- <Row type="flex" justify="center" class="margin-top-10 page-nation">
      <Page
        :total="totalCount"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        :page-size="pageSize"
        :current="currentPage"
        show-total
        :page-size-opts="[10, 20, 30, 40, 50]"
      ></Page>
    </Row> -->
  </div>
</template>

<script>
import debounce from "../libs/debounce";
export default {
  name: "OfficeListPhone",
  props: {
    // onSelected: {
    //     type: Function
    // },
    areaRanges: { type: Array },
    cityIds: { type: Array },
    projectIds: { type: Array },
    rentPriceRanges: { type: Array },
    orderByType: Number,
  },
  data() {
    return {
      officeCont: [
        {
          id: "11",
          image: require("../assets/images/web/listPic1.jpg"),
          projectTit: "源创谷 1号楼 402",
          addr: "上海市浦东新区盛荣路88弄",
          area: "74.00m²",
          rent: "4.60元/m²/天",
          manageFee: "21元/m²/月",
          standards: "标准交付",
          houseType: "现房",
          equipment: "中央空调",
        },
        {
          id: "22",
          image: require("../assets/images/web/listPic2.jpg"),
          projectTit: "源创谷 1号楼 402",
          addr: "上海市浦东新区盛荣路88弄",
          area: "74.00m²",
          rent: "4.60元/m²/天",
          manageFee: "21元/m²/月",
          standards: "标准交付",
          houseType: "现房",
          equipment: "中央空调",
        },
        {
          id: "33",
          image: require("../assets/images/web/listPic3.jpg"),
          projectTit: "源创谷 1号楼 402",
          addr: "上海市浦东新区盛荣路88弄",
          area: "74.00m²",
          rent: "4.60元/m²/天",
          manageFee: "21元/m²/月",
          standards: "标准交付",
          houseType: "现房",
          equipment: "中央空调",
        },
      ],
      loading: false,
      totalCount: 0,
      currentPage: 1,
      pageSize: 3,
      datas: [],
    };
  },
  methods: {
    getPage: debounce(function () {
      this.loading = true;
      const skipCount = this.datas.length; //(this.currentPage - 1) * this.pageSize;
      return this.$http
        .post("/api/services/app/CommonWeb/SearchRooms", {
          maxResultCount: this.pageSize,
          skipCount: skipCount,
          areaIds: [],
          businessDistrictIds: [],
          roomIds: [],
          areaRanges: this.areaRanges,
          cityIds: this.cityIds,
          projectIds: this.projectIds,
          rentPriceRanges: this.rentPriceRanges,
          orderByType: this.orderByType,
        })
        .then((res) => {
          console.log(this.datas);
          this.datas.push(
            ...res.data.result.items.filter(
              (item) => !this.datas.some((dataItem) => dataItem.roomId === item.roomId)
            )
          );
          this.totalCount = res.data.result.totalCount;
          console.log(this.totalCount);
          console.log(this.datas);
        })
        .finally(() => {
          this.loading = false;
        });
    }, 500),
    officeDetail(result) {
      this.$router.push({
        path: "/officeDetail",
        query: { roomId: result.roomId, projectId: result.projectBasicId },
      });
    },
    handleReachBottom(event) {
      if (
        event.target.scrollHeight <=
        event.target.clientHeight + event.target.scrollTop + 36
      ) {
        this.getPage();
      }
    },
  },
  mounted() {
    // this.getPage();
  },
  watch: {
    areaRanges: {
      deep: true,
      handler: function (value) {
        console.log(value);
        this.totalCount = 0;
        this.currentPage = 1;
        this.pageSize = 3;
        this.datas = [];
        this.getPage();
      },
    },
    cityIds: {
      deep: true,
      handler: function (value) {
        console.log(value);
        this.totalCount = 0;
        this.currentPage = 1;
        this.pageSize = 3;
        this.datas = [];
        this.getPage();
      },
    },
    projectIds: {
      deep: true,
      handler: function (value) {
        console.log(value);
        this.totalCount = 0;
        this.currentPage = 1;
        this.pageSize = 3;
        this.datas = [];
        this.getPage();
      },
    },
    rentPriceRanges: {
      deep: true,
      handler: function (value) {
        console.log(value);
        this.totalCount = 0;
        this.currentPage = 1;
        this.pageSize = 3;
        this.datas = [];
        this.getPage();
      },
    },
    orderByType: {
      deep: true,
      handler: function (value) {
        console.log(value);
        this.totalCount = 0;
        this.currentPage = 1;
        this.pageSize = 3;
        this.datas = [];
        this.getPage();
      },
    },
  },
};
</script>

<style lang="less">
.office-list-phone{
  /*margin-bottom: 30px;*/
  /*overflow-y: scroll;*/
  overflow-x: hidden;
  /*解决ios上滑动不流畅*/
  -webkit-overflow-scrolling: touch;
  .scroll-container {
    height: 680px;
    overflow-y: auto;
    width: 100%;
    position: relative;
    .list-empty {
      width: 100%;
      height: 130px;
      text-align: center;
      line-height: 130px;
    }
    .ivu-card {
      margin-bottom: 15px;
      .ivu-card-body {
        padding: 0;
        cursor: pointer;
        .office-img {
          line-height: 0;
          width:100px;
          height:90px !important;
          img {
            height:90px !important;
            width:100px;
          }
        }

        .right-msg {
          padding: 5px 10px;
          text-align: left;

          h3 {
            font-size: 14px;
            padding-bottom: 6px;
            /*width: 290px;*/
            overflow: hidden;/*不允许滚动条*/
            white-space: nowrap;/*不允许文本换行*/
            text-overflow: ellipsis;/*文本超长显示省略号*/
          }

          .addr {
            color: #999999;
            font-size: 12px;
            padding-bottom: 8px;
            /*width: 290px;*/
            overflow: hidden;/*不允许滚动条*/
            white-space: nowrap;/*不允许文本换行*/
            text-overflow: ellipsis;/*文本超长显示省略号*/
            .ivu-icon {
              font-size: 14px;
            }
          }
          .addr:hover{
            width: auto;
          }
          .o-msg {
            margin-bottom: 10px;

            li {
              font-size: 12px;
              color: #666666;
              line-height: 18px;
            }
          }

          .o-condition {
            display: flex;
            flex-flow: row;

            span {
              display: inline-block;
              margin-right: 10px;
              border: 1px solid #f5f5f5;
              padding: 2px 5px;
              border-radius: 5px;
              font-size:12px;
            }
          }
        }
      }
    }
    .loading {
      display: inline-block;
      height: 36px;
      width: 100%;
      position: relative;
      border: 1px solid #eee;
    }
    // .page-nation {
    //   margin-bottom: 30px;
    //   .ivu-page-item-active {
    //     border-color: #3376fe;
    //     a {
    //       color: #3376fe;
    //     }
    //   }
    //   .ivu-page-item:hover {
    //     border-color: #3376fe;
    //     a {
    //       color: #3376fe;
    //     }
    //   }
    // }
  }
  .scroll-container::-webkit-scrollbar{
    display: none;
  }
}
</style>
